// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__AfRAD","content":"styles_content__U-i7F","checkbox":"styles_checkbox__24xkd","checkboxLabel":"styles_checkboxLabel__c6UDF"};